var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "toast-c" }, [
        _vm.successIcon
          ? _c("img", { attrs: { src: require("../images/icon_success.png") } })
          : _vm._e(),
        _vm._v("\n\t\t" + _vm._s(_vm.msg) + "\n\t\t"),
        _vm.richText
          ? _c("span", { domProps: { innerHTML: _vm._s(_vm.richText) } })
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }